
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import MenuItem from '@material-ui/core/MenuItem';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {
  createreportFoundIt,
} from '../api/reportFoundIt.api';
import { getAllitem } from '../api/item.api';

import { getUsers } from '../api/user.api';

const LoftyreportFoundItAddModal = ({open, handleClose, successAction, token}) => {
  const [dataLoftyitem, setDataLoftyitem] = useState([]);

  const [dataUser, setDataUser] = useState([]);

  useEffect(() => {
    const handleDataLoftyApps = async () => {
      try {
				const resLoftyitem = await getAllitem({ token });
				setDataLoftyitem(resLoftyitem.data);

				const resUser = await getUsers({ token });
				setDataUser(resUser.data);

      } catch (error) {
        // error
      }
    }
    handleDataLoftyApps();
  }, []);
  return (
    <Dialog fullWidth open={open} onClose={handleClose}>
      <DialogTitle>
        Agregar reportFoundIt
      </DialogTitle>
      <DialogContent>
        <form
          onSubmit={async e => {
            e.preventDefault();
            try {
              await createreportFoundIt({
                token: token,
                userId: e.target.userId.value,
							idItem: e.target.idItem.value,
							image: e.target.image.value,
							createdAt: e.target.createdAt.value,
							details: e.target.details.value,
							address: e.target.address.value,
							contact: e.target.contact.value,

              });
              if (successAction) {
                successAction();
              }
              alert('Se agrego exitosamente el dato');
            } catch (error) {
              if (error.info) {
                alert(error.info);
              } else {
                alert('Lo sentimos no se logro agregar el dato');
              }
            }
          }}
        >
  				<div className="my-3">
					<TextField name="userId" label="Usuario" variant="outlined" fullWidth select>
						{
							dataUser.map(item => (
								<MenuItem key={item._id} value={item._id}>{item.loftyEmail}</MenuItem>
							))
						}
					</TextField>
				</div>
				<div className="my-3">
					<TextField name="idItem" label="Objeto" variant="outlined" fullWidth select>
						{
							dataLoftyitem.map(item => (
								<MenuItem key={item._id} value={item._id}>{item.description}</MenuItem>
							))
						}
					</TextField>
				</div>
				<div className="my-3">
					<TextField type="text" name="image" label="Imagen" variant="outlined" fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="createdAt" label="Fecha de creacion " variant="outlined" fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="details" label="Detalle" variant="outlined" fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="address" label="Direccion" variant="outlined" fullWidth />
				</div>
				<div className="my-3">
					<TextField type="text" name="contact" label="Contacto" variant="outlined" fullWidth />
				</div>

          <div className="my-3 text-center">
            <Button type="submit" variant="outlined" color="primary">
              Guardar
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = state => state.auth;

export default connect(mapStateToProps)(LoftyreportFoundItAddModal);
